import { render } from "./CardQuestion.vue?vue&type=template&id=666bc51c&scoped=true"
import script from "./CardQuestion.vue?vue&type=script&lang=js"
export * from "./CardQuestion.vue?vue&type=script&lang=js"

import "./CardQuestion.vue?vue&type=style&index=0&id=666bc51c&lang=scss&scoped=true"
import "./CardQuestion.vue?vue&type=style&index=1&id=666bc51c&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-666bc51c"]])

export default __exports__